const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiEndpoints = {
  getQuestions: () => `${API_BASE_URL}/eeva/getQuestions`,
  getClientInfoByDomain: () => `${API_BASE_URL}/eeva/getClientInfoByDomain`,
  getPromotions: () => `${API_BASE_URL}/eeva/getPromotionalAds`,
  postUserResponse: (userResponse: any) =>
    `${API_BASE_URL}/eeva/postUserResponse`,
  getAIResponse: (userRequest: any) => `${API_BASE_URL}/ai/eevaairesponse/add`,
};

export default apiEndpoints;
